import * as Common from '@tfo/common'
import { ClientViewStore } from '../../../../../../stores/ClientViewStore'
import { IOrderClient } from '@tfo/common/src/models'
import { observer } from 'mobx-react'
import * as React from 'react'
import { ReportState } from '../../ReportsEnums'
import ReportsItemArchived from './components/ReportsItemArchived'
import ReportsItemDelivered from './components/ReportsItemDelivered'
import ReportsItemWaitingApproval from './components/ReportsItemWaitingApproval'
import './ReportsItem.scss'
import ReportsItemOngoing from './components/ReportsItemOngoing'


const State = Common.models.State

export interface ReportsItemProps {
	data: Common.models.IOrderClient
	onClick: Function
	reportPackages: any[]
	store: ClientViewStore
}

const ReportsItem = (props: ReportsItemProps) => {
	const { data, onClick, reportPackages, store } = props

	const onUpdateOrder = (order: IOrderClient): void => {
		const index = store.reportsStore.orders.findIndex(x => x.id === order.id)
		store.reportsStore.orders[index] = order
	}

	const onRemoveOrder = (order: IOrderClient): void => {
		store.reportsStore.removeOrder(order);
	}

	if (store.reportsStore.activeStateFilter === ReportState.Archived) {
		return (
			<ReportsItemArchived
				data={data}
				onClick={onClick}
				reportPackages={reportPackages}
				showCompanyName={props.store.reportsStore.hasSubsidaries}
			/>
		)
	}

	switch (data.state) {
		case State.Delivered:
			return (
				<ReportsItemDelivered
					data={data}
					onClick={onClick}
					reportPackages={reportPackages}
					showCompanyName={props.store.reportsStore.hasSubsidaries}
					isUnread={store.reportsStore.isUnreadForUser(data)}
				/>
			)
		case State.ResearchCompleted:
		case State.ResearchInProgress:
		case State.WaitingForResearcher:
		case State.ConsentGiven:
			return (
				<ReportsItemOngoing
					data={data}
					onClick={onClick}
					onRemoveOrder={onRemoveOrder}
					reportPackages={reportPackages}
					showCompanyName={props.store.reportsStore.hasSubsidaries}
				/>
			)
		default:
			return (
				<ReportsItemWaitingApproval
					data={data}
					reportPackages={reportPackages}
					showCompanyName={props.store.reportsStore.hasSubsidaries}
					updateOrder={onUpdateOrder}
					removeOrder={onRemoveOrder}
				/>
			)
	}
}

export default observer(ReportsItem)
